export default {
  methods: {
    getAppointmenttypeactions(appointmenttype) {
      let actions = [
        { type: 'divider' },
        {
          id: 'archive',
          icon: 'mdi-archive',
          title: 'Archive',
          attrs: {
            color: 'error',
            class: 'red--text'
          },
          onclick: () => {
            console.log(appointmenttype)
          }
        }
      ]
      return actions
    }
  }
}